export default __webpack_public_path__ + "static/media/moon.5e3bd168.svg";